import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Iter v34bd — Dropdown nama dari Master Batching (senders / receivers / drivers).
 *
 * Props:
 *  - source        : "senders" | "receivers" | "drivers"
 *  - value (string): current name
 *  - onPick (fn)   : ({ name }) => void
 *  - placeholder?, "data-testid"?
 */
export default function BatchingNamePicker({ source, value, onPick, placeholder, ...rest }) {
  const [opts, setOpts] = useState([]);
  useEffect(() => {
    let mounted = true;
    api.get(`/batching/${source}`).then((r) => { if (mounted) setOpts(r.data || []); }).catch(() => {});
    return () => { mounted = false; };
  }, [source]);
  const hasCurrent = !value || opts.some((o) => o.name === value);
  return (
    <select
      value={value || ""}
      onChange={(e) => onPick({ name: e.target.value })}
      className="w-full border border-stone-300 bg-white px-3 py-2 text-sm focus:border-terra-500 focus:ring-1 focus:ring-terra-500 outline-none"
      {...rest}
    >
      <option value="">{placeholder || "— Pilih Nama —"}</option>
      {!hasCurrent && <option value={value}>{value} (lama)</option>}
      {opts.map((o) => (
        <option key={o.id || o.name} value={o.name}>
          {o.note ? `${o.name} — ${o.note}` : o.name}
        </option>
      ))}
    </select>
  );
}
